import { parseOptions } from "@/components/Charts/optionHelpers";
import { convertCount } from "@/common/functions";
export const Charts = {
  mode: "light", // (themeMode) ? themeMode : 'light';
  fonts: {
    base: "NeutrifPro",
  },
  colors: {
    gray: {
      100: "#f6f9fc",
      200: "#e9ecef",
      300: "#dee2e6",
      400: "#ced4da",
      500: "#adb5bd",
      600: "#576E87",
      700: "#525f7f",
      800: "#32325d",
      900: "#212529",
    },
    theme: {
      default: "#172b4d",
      primary: "#03045E",
      secondary: "#201F35",
      info: "#11cdef",
      success: "#2dce89",
      danger: "#f5365c",
      warning: "#fb6340",
    },
    black: "#12263F",
    white: "#FFFFFF",
    transparent: "transparent",
  },
};

function chartOptions(Chart) {
  let { colors, mode, fonts } = Charts;
  // Options
  let options = {
    defaults: {
      global: {
        responsive: true,
        maintainAspectRatio: false,
        defaultColor: mode === "dark" ? colors.gray[700] : colors.gray[600],
        defaultFontColor: mode === "dark" ? colors.gray[700] : colors.gray[600],
        defaultFontFamily: fonts.base,
        defaultFontSize: 13,
        layout: {
          padding: 0,
        },
        legend: {
          display: false,
          position: "bottom",
          labels: {
            usePointStyle: true,
            padding: 16,
          },
        },
        elements: {
          point: {
            radius: 0,
            backgroundColor: colors.theme["primary"],
          },
          line: {
            tension: 0.6,
            borderWidth: 3,
            borderColor: colors.theme["primary"],
            backgroundColor: colors.transparent,
            borderCapStyle: "rounded",
          },
          rectangle: {
            backgroundColor: colors.theme["secondary"],
          },
          arc: {
            backgroundColor: colors.theme["primary"],
            borderColor: mode === "dark" ? colors.gray[800] : colors.white,
            borderWidth: 0,
          },
        },
        tooltips: {
          enabled: true,
          mode: "index",
          intersect: true,
        },
      },
      doughnut: {
        cutoutPercentage: 83,
        legendCallback: function (chart) {
          let data = chart.data;
          let content = "";

          data.labels.forEach(function (label, index) {
            let bgColor = data.datasets[0].backgroundColor[index];

            content += '<span class="chart-legend-item">';
            content +=
              '<i class="chart-legend-indicator" style="background-color: ' +
              bgColor +
              '"></i>';
            content += label;
            content += "</span>";
          });

          return content;
        },
      },
    },
  };

  // yAxes
  Chart.scaleService.updateScaleDefaults("linear", {
    gridLines: {
      borderDash: [2],
      borderDashOffset: [7],
      color: mode === "dark" ? colors.gray[300] : colors.gray[300],
      drawBorder: false,
      drawTicks: false,
      lineWidth: 1,
      zeroLineWidth: 0,
      zeroLineColor: mode === "dark" ? colors.gray[300] : colors.gray[300],
      zeroLineBorderDash: [2],
      zeroLineBorderDashOffset: [2],
    },
    ticks: {
      beginAtZero: true,
      padding: 10,
      callback: function (value) {
        if (!(value % 1)) {
          return value;
        }
      },
    },
  });

  // xAxes
  Chart.scaleService.updateScaleDefaults("category", {
    gridLines: {
      drawBorder: false,
      drawOnChartArea: false,
      drawTicks: false,
    },
    ticks: {
      padding: 20,
    },
    maxBarThickness: 10,
  });

  return options;
}

export function initGlobalOptions(Chart) {
  parseOptions(Chart, chartOptions(Chart));
}

export const basicOptions = {
  maintainAspectRatio: false,
  legend: {
    display: false,
  },
  responsive: true,
};
var arr = [];
export let blueChartOptions = {
  tooltips: {
    backgroundColor: "#020A13",
    titleFontColor: "#fff",
    bodyFontColor: "#fff",
    enabled: true,
    callbacks: {
      label: (tooltipItems) => {
        return convertCount(tooltipItems.yLabel) + " Sent";
      },
      title: (tooltipItems, data) => {
        var split = data.labels[tooltipItems[0].index].split("_");
        if (split[1]) {
          return split[0];
        } else {
          return data.labels[tooltipItems[0].index];
        }
      },
    },
  },
  scales: {
    yAxes: [
      {
        gridLines: {
          color: Charts.colors.gray[300],
          zeroLineColor: Charts.colors.gray[300],
        },
        ticks: {
          maxTicksLimit: 8,
          callback: function (value) {
            if (!(value % 10)) {
              if (value >= 1000) {
                return value / 1000 + " K";
              }

              return value;
            }
            return value;
          },
        },
      },
    ],
    xAxes: [
      {
        stacked: true,
        ticks: {
          maxTicksLimit: 7,
          maxRotation: 0,
          callback: function (value, value1) {
            if (!value1) {
              arr = [];
            }

            var split = value.split("_");
            if (split[1]) {
              if (arr.includes(split[1])) {
                return "";
              }
              if (
                [
                  0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 24, 26, 28, 30,
                ].includes(value1)
              ) {
                arr.push(split[1]);
              }
              return split[1];
            }
            return value;
          },
        },
      },
    ],
  },
};

var openArr = [];
export let openChartOptions = {
  tooltips: {
    enabled: true,
    callbacks: {
      label: (tooltipItems) => {
        return tooltipItems.yLabel + " Open";
      },
      title: (tooltipItems, data) => {
        var split = data.labels[tooltipItems[0].index].split("_");
        if (split[1]) {
          return split[0];
        } else {
          return data.labels[tooltipItems[0].index];
        }
      },
    },
  },
  scales: {
    yAxes: [
      {
        gridLines: {
          color: Charts.colors.gray[300],
          zeroLineColor: Charts.colors.gray[300],
        },
        ticks: {
          maxTicksLimit: 8,
          callback: function (value) {
            if (!(value % 10)) {
              if (value >= 1000) {
                return value / 1000 + " K";
              }

              return value;
            }
            return value;
          },
        },
      },
    ],
    xAxes: [
      {
        stacked: true,
        ticks: {
          maxTicksLimit: 10,
          maxRotation: 0,
          callback: function (value, value1) {
            if (!value1) {
              openArr = [];
            }

            var split = value.split("_");
            if (split[1]) {
              if (openArr.includes(split[1])) {
                return "";
              }
              if (
                [
                  0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 24, 26, 28, 30,
                ].includes(value1)
              ) {
                openArr.push(split[1]);
              }
              return split[1];
            }
            return value;
          },
        },
      },
    ],
  },
};

export let lineChartOptionsBlue = {
  ...basicOptions,
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },
  responsive: true,
  scales: {
    yAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(29,140,248,0.0)",
          zeroLineColor: "transparent",
        },
        ticks: {
          suggestedMin: 60,
          suggestedMax: 125,
          padding: 20,
          fontColor: "#9e9e9e",
        },
      },
    ],

    xAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(29,140,248,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          padding: 20,
          fontColor: "#9e9e9e",
        },
      },
    ],
  },
};

export let barChartOptionsGradient = {
  ...basicOptions,
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },
  responsive: true,
  scales: {
    yAxes: [
      {
        gridLines: {
          drawBorder: false,
          color: "rgba(253,93,147,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          suggestedMin: 60,
          suggestedMax: 125,
          padding: 20,
          fontColor: "#9e9e9e",
        },
      },
    ],

    xAxes: [
      {
        gridLines: {
          drawBorder: false,
          color: "rgba(253,93,147,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          padding: 20,
          fontColor: "#9e9e9e",
        },
      },
    ],
  },
};

export let pieChartOptions = {
  ...basicOptions,
  cutoutPercentage: 0,
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },

  scales: {
    yAxes: [
      {
        display: 0,
        ticks: {
          display: false,
        },
        gridLines: {
          drawBorder: false,
          zeroLineColor: "transparent",
          color: "rgba(255,255,255,0.05)",
        },
      },
    ],

    xAxes: [
      {
        display: 0,
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(255,255,255,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          display: false,
        },
      },
    ],
  },
};

export let purpleChartOptions = {
  ...basicOptions,
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },
  scales: {
    yAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(29,140,248,0.0)",
          zeroLineColor: "transparent",
        },
        ticks: {
          suggestedMin: 60,
          suggestedMax: 125,
          padding: 20,
          fontColor: "#9a9a9a",
        },
      },
    ],

    xAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(225,78,202,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          padding: 20,
          fontColor: "#9a9a9a",
        },
      },
    ],
  },
};

export let orangeChartOptions = {
  ...basicOptions,
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },
  scales: {
    yAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(29,140,248,0.0)",
          zeroLineColor: "transparent",
        },
        ticks: {
          suggestedMin: 50,
          suggestedMax: 110,
          padding: 20,
          fontColor: "#ff8a76",
        },
      },
    ],

    xAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(220,53,69,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          padding: 20,
          fontColor: "#ff8a76",
        },
      },
    ],
  },
};
export let greenChartOptions = {
  ...basicOptions,
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },
  scales: {
    yAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(29,140,248,0.0)",
          zeroLineColor: "transparent",
        },
        ticks: {
          suggestedMin: 50,
          suggestedMax: 125,
          padding: 20,
          fontColor: "#9e9e9e",
        },
      },
    ],

    xAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(0,242,195,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          padding: 20,
          fontColor: "#9e9e9e",
        },
      },
    ],
  },
};

export let barChartOptions = {
  ...basicOptions,
  tooltips: {
    callbacks: {
      label: (tooltipItems, data) => {
        return (
          data["datasets"][tooltipItems["datasetIndex"]].label +
          ": " +
          convertCount(tooltipItems.yLabel)
        );
      },
      title: (tooltipItems, data) => {
        var split = data.labels[tooltipItems[0].index].split("_");
        if (split[1]) {
          return split[0];
        }
      },
    },
    backgroundColor: "#020A13",
    titleFontColor: "#fff",
    bodyFontColor: "#fff",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },
  cornerRadius: 10,
  fullCornerRadius: false,
  scales: {
    yAxes: [
      {
        gridLines: {
          drawBorder: false,
          color: "rgba(222,226,230,1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          maxTicksLimit: 6,
          suggestedMin: 6,
          suggestedMax: 6,
          padding: 0,
          fontColor: "#576E87",
          callback: function (value) {
            if (value >= 1000) {
              return value / 1000 + " K";
            }
            return value;
          },
        },
        stacked: true,
      },
    ],
    xAxes: [
      {
        gridLines: {
          drawBorder: false,
          color: "rgba(29,140,248,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          maxTicksLimit: 7,
          maxRotation: 0,
          callback: function (value) {
            var split = value.split("_");
            if (split[1]) {
              return split[1];
            }
            return value;
          },
          padding: 20,
          fontColor: "#576E87",
        },
        stacked: true,
      },
    ],
  },
  legend: {
    display: false,
    position: "top",
    fullWidth: true,
    alignment: "right",
    labels: {
      boxWidth: 8,
      fontSize: 12,
    },
  },
};
